import { defineComponent as r, computed as a, openBlock as l, createElementBlock as c, normalizeClass as p, renderSlot as m } from "vue";
const g = /* @__PURE__ */ r({
  __name: "Tag",
  props: {
    color: {}
  },
  setup(e) {
    const o = e, s = /* @__PURE__ */ new Map([
      ["yellow", "bg-yellow"],
      ["gray", "bg-gray"]
    ]), n = a(() => s.get(o.color));
    return (t, u) => (l(), c("span", {
      class: p([n.value, "rounded px-1.5 py-0.5 text-sm font-medium"])
    }, [
      m(t.$slots, "default")
    ], 2));
  }
});
export {
  g as _
};
